module.exports = __webpack_public_path__ + "static/media/logo.089aa178.svg";